import React, { FC } from 'react'
import { ButtonComponentProps } from '../Button/ButtonComponent'
import { FiShoppingCart } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import { CombinedReducers } from 'app_events/index'
import {useSyncShoppingCart} from 'app_hooks/useSyncShoppingCart'
import './ShoppingCartIcon.scss'

interface IShoppingCarProps extends ButtonComponentProps {}

const ShoppingCartIcon: FC<IShoppingCarProps> = ({ ...props }) => {
  const {data: shoppingCarItems} = useSelector((store: CombinedReducers) => store?.app?.shoppingCart ?? {action: 'none', data: []});
  useSyncShoppingCart();

  return (
    <div className={`shopping-cart-icon-wrapper ${shoppingCarItems.length > 0 ? 'has-items' : ''}`}>
      <FiShoppingCart className='shopping-cart-icon' />
      {shoppingCarItems.length > 0 && (
        <span className='badge badge-pill badge-primary'>{shoppingCarItems.length}</span>
      )}
    </div>
  )
}

export default ShoppingCartIcon
